<template>
  <div id="xy_bcom" class="relativeItem">
    <div class="btn_con">
      <div class="zi_b_box flex-box">
        <p
          :class="['p_btn', { btnActive: btnAc == 0 }, { mar_l: btnAc == 0 }]"
          @click="btnClick(0)"
        >
          主播榜
        </p>
        <p
          :class="['p_btn', { btnActive: btnAc == 1 }, { mar_r: btnAc == 1 }]"
          @click="btnClick(1)"
        >
          用户榜
        </p>
      </div>
    </div>
    <div class="relativeItem" v-if="isStart == 1 || isStart == 2">
      <!-- 数组数据不足三个的显示 -->
      <div class="two_b" v-if="rankList.length < 3">
        <ul class="f_ten_box f_two_con">
          <li class="flex-box ali_ctr lis" v-for="(n, i) in rankList" :key="i">
            <div class="line_div flex-box ali_ctr">
              <div class="idx_box">
                {{ i + 1 }}
              </div>
              <div class="info_div flex-box ali_ctr">
                <div class="avtar_div" :data-uid="n.user_id" @click="linkto">
                  <img
                    class="imgBlock noevents-img"
                    :src="n.heade_portrait"
                    onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                  />
                </div>
                <p class="name_box apostrophe">{{ n.user_name }}</p>
              </div>
            </div>

            <div class="flex-box r_numdiv">
              <p>
                已实现<i> {{ n.num }} </i>心愿
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="list_main" v-if="rankList.length >= 3">
        <!-- 前三名数据 -->
        <div class="three_box flex-box" v-if="rankList.length != 0">
          <!-- 第二名 -->
          <div class="reward_box relativeItem" v-if="rankList.length > 1">
            <img
              class="imgBlock noevents-img blue_bg"
              src="../../assets/xyuan/bgimg00.png"
            />
            <div class="absoluteItem centerX one_three">
              <div class="avatar_main relativeItem">
                <img
                  class="imgBlock noevents-img bg_img"
                  src="../../assets/xyuan/2img.png"
                />
                <div class="head_box head_01 absoluteItem">
                  <div
                    class="small_box"
                    :data-uid="rankList[1].user_id"
                    @click="linkto"
                  >
                    <img
                      class="imgBlock noevents-img"
                      :src="rankList[1].heade_portrait"
                      onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                  </div>
                </div>
              </div>
              <div class="uname_div apostrophe">
                {{ rankList[1].user_name }}
              </div>
              <div class="num_box flex-box">
                <p>
                  已实现 <i> {{ rankList[1].num }} </i>心愿
                </p>
              </div>
            </div>
          </div>
          <!-- 第一名 -->
          <div class="reward_box relativeItem" v-if="rankList.length > 0">
            <img
              class="imgBlock noevents-img blue_bg"
              src="../../assets/xyuan/bgimg00.png"
            />
            <div class="absoluteItem centerX info_con">
              <div class="avatar_main relativeItem">
                <img
                  class="imgBlock noevents-img bg_img"
                  src="../../assets/xyuan/1img.png"
                />
                <div class="head_box head_01 absoluteItem">
                  <div
                    class="small_box"
                    :data-uid="rankList[0].user_id"
                    @click="linkto"
                  >
                    <img
                      class="imgBlock noevents-img"
                      :src="rankList[0].heade_portrait"
                      onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                  </div>
                </div>
              </div>

              <div class="uname_div apostrophe">
                {{ rankList[0].user_name }}
              </div>
              <div class="num_box flex-box">
                <p>
                  已实现 <i> {{ rankList[0].num }} </i>心愿
                </p>
              </div>
            </div>
          </div>
          <!-- 第三名 -->
          <div class="reward_box relativeItem" v-if="rankList.length > 2">
            <img
              class="imgBlock noevents-img blue_bg"
              src="../../assets/xyuan/bgimg00.png"
            />
            <div class="absoluteItem centerX one_three">
              <div class="avatar_main relativeItem">
                <img
                  class="imgBlock noevents-img bg_img"
                  src="../../assets/xyuan/3img.png"
                />
                <div class="head_box head_01 absoluteItem">
                  <div
                    class="small_box"
                    :data-uid="rankList[2].user_id"
                    @click="linkto"
                  >
                    <img
                      class="imgBlock noevents-img"
                      :src="rankList[2].heade_portrait"
                      onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                  </div>
                </div>
              </div>
              <div class="uname_div apostrophe">
                {{ rankList[2].user_name }}
              </div>
              <div class="num_box flex-box">
                <p>
                  已实现 <i> {{ rankList[2].num }} </i>心愿
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 四至十名 -->
        <ul class="f_ten_box" v-if="rankList.length > 3">
          <li
            class="flex-box ali_ctr lis"
            v-for="(n, i) in rankList.slice(3)"
            :key="i"
          >
            <div class="line_div flex-box ali_ctr">
              <div class="idx_box">
                {{ i + 4 }}
              </div>
              <div class="info_div flex-box ali_ctr">
                <div class="avtar_div" :data-uid="n.user_id" @click="linkto">
                  <img
                    class="imgBlock noevents-img"
                    :src="n.heade_portrait"
                    onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                  />
                </div>
                <p class="name_box apostrophe">{{ n.user_name }}</p>
              </div>
            </div>

            <div class="flex-box r_numdiv">
              <p>
                已实现<i> {{ n.num }} </i>心愿
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div class="over_box absoluteItem centerX" v-show="isStart == 2">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xyuan/21(19).png"
        />
        <p class="over_p absoluteItem centerImg">很抱歉，当前活动已结束了哦~</p>
      </div>
    </div>
    <!-- 空数据的展示 -->
    <div v-show="isShowblank" class="nostart_con absoluteItem">
      <div v-if="isStart == 1">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xyuan/blankimg.png"
        />
        <p class="text_no">- 暂无数据 -</p>
      </div>
    </div>

    <!-- 活动未开始的 -->
    <div class="nostart_con absoluteItem" v-if="isStart == 0">
      <img
        class="imgBlock noevents-img"
        src="../../assets/xyuan/blankimg.png"
      />
      <p class="text_no">- 暂未开始 -</p>
      <p class="p_te">本活动将于1月15日00:00:00开始，敬请期待哦~</p>
    </div>
  </div>
</template>









<script>
export default {
  name: "xy_bcom",
  props: ["isStart"],
  data() {
    return {
      isShowblank: false, // 显示空数据的flag
      btnAc: 0, //按钮的选中
      rankList: [],
      zhuList: [],
      userList: [],
    };
  },
  mounted() {
    this.getRankList();
  },
  methods: {
    btnClick(idx) {
      this.btnAc = idx;
      if (this.btnAc == 0) {
        // 主播榜数据赋值
        this.rankList = [];
        this.rankList = this.zhuList;
        if (this.zhuList.length == 0) {
          this.isShowblank = true;
        } else {
          this.isShowblank = false;
        }
      } else {
        //   用户帮数据赋值
        this.rankList = [];
        this.rankList = this.userList;
        if (this.userList.length == 0) {
          this.isShowblank = true;
        } else {
          this.isShowblank = false;
        }
      }
      this.setOverShow();
    },

    // 设置活动结束的显示隐藏
    setOverShow() {
      if (this.isStart == 2) {
        let overEle = document.querySelector(".over_box");
        overEle.style.display = "block";
        setTimeout(() => {
          overEle.style.display = "none";
        }, 3000);
      }
    },

    // 获取排行榜
    getRankList() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("xy_getRanklist"), data, (res) => {
        _this.zhuList = res.data.data.anchor_rank_list;
        _this.userList = res.data.data.user_rank_list;
        if (_this.zhuList.length == 0) {
          _this.isShowblank = true;
        }
        _this.rankList = _this.zhuList;
      });
    },

    /**点击跳转 */
    linkto(e) {
      this.$tool.to_person_page(e);
    },
  },
};
</script>








<style scoped>
#xy_bcom {
  width: 100%;
  min-height: 400px;
  padding-top: 20px;
}
/* 按钮区域 */
.btn_con {
  width: 55%;
  height: 34px;
  line-height: 34px;
  margin: auto;
  background-color: #761ec2;
  border-radius: 50px;
  box-sizing: border-box;
  padding: 1px;
}
.zi_b_box {
  width: 100%;
  height: 32px;
  background-color: #3b0a71;
  border-radius: 50px;
}
.p_btn {
  width: 50%;
  text-align: center;
  font-size: 13px;
  color: #b19dc6;
  line-height: 34px;
}
.btn_con .zi_b_box .mar_r {
  margin-right: -1px;
}
.btn_con .zi_b_box .mar_l {
  margin-left: -1px;
}
.btn_con .btnActive {
  height: 100%;
  height: 33px;
  margin-top: -1px;
  line-height: 33px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to bottom, #ac4bcd, #5d1496);
  background: -webkit-linear-gradient(top, #ac4bcd, #5d1496);
  border: 1px solid #ce7aff;
  border-radius: 50px;
}

/* 列表信息 */
.list_main {
  width: 100%;
  padding-top: 47px;
}
.three_box {
  width: 100%;
  padding: 0.5rem 1.2rem 1.2rem;
}
.reward_box {
  width: 35%;
  text-align: center;
}
.reward_box .blue_bg {
  width: 92%;
  margin: auto;
}
.three_box .reward_box:nth-child(1),
.three_box .reward_box:nth-child(3) {
  margin-top: 1.8rem;
}
i {
  font-style: normal;
}
.avatar_main .bg_img {
  width: 70%;
  margin-left: 10%;
}
.num_box {
  margin-top: 6px;
  align-items: baseline;
  justify-content: center;
  font-size: 0.6875rem;
  color: #fff495;
}
.num_box p i {
  font-weight: bold;
}
.uname_div {
  width: 80%;
  margin: auto;
  margin-top: 8px;
  font-size: 0.8125rem;
  color: #fff;
}
.head_box {
  width: 57%;
  right: 21%;
  bottom: 0;
  overflow: hidden;
  margin: auto;
  margin-top: 0.28rem;
  box-sizing: border-box;
  padding: 2px;
  border-radius: 50%;
  background: #f6af41;
}
.avatar_main .head_01 {
  background-color: #afafaf;
}
.avatar_main .head_03 {
  background-color: #f7835b;
}
.head_box img {
  width: 100%;
}
.small_box {
  border-radius: 50%;
  overflow: hidden;
}

.avatar_main .head_c {
  background-image: -webkit-linear-gradient(top, #f9c376, #e1a556);
  background-image: linear-gradient(to bottom, #f9c376, #e1a556);
}

.avatar_main .head_r {
  background-image: -webkit-linear-gradient(top, #dfab81, #af804e);
  background-image: linear-gradient(to bottom, #dfab81, #af804e);
}
.info_con {
  width: 100%;
  top: -21%;
}

.one_three {
  width: 100%;
  top: -27%;
}
/* 四到十名的样式 */
.two_b .f_two_con {
  margin-top: 8px;
}
.f_ten_box {
  width: 100%;
  padding: 0 1.5rem 0 1.5rem;
  margin-top: -60px;
}
.f_ten_box li {
  padding: 2.1% 0;
  width: 100%;
  border-top: 1px solid #5d1a96;
}
.f_ten_box li:nth-child(1) {
  border-top: none;
}

.f_ten_box .lis.lisAdd {
  padding: 3.2% 0;
}
.line_div {
  width: 62%;
}
.ali_ctr {
  align-items: center;
}
.idx_box {
  width: 20px;
  text-align: center;
  font-size: 0.875rem;
  color: #fff;
}
.info_div {
  width: 80%;
  margin-left: 16px;
}
.info_div .avtar_div {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #9870ec;
}
.avtar_div img {
  width: 100%;
}

.info_div .name_box {
  width: 57%;
  margin-left: 19px;
  font-size: 0.8125rem;
  color: rgb(255, 255, 255);
}
.r_numdiv {
  margin-left: 20px;
  align-items: baseline;
}
.r_numdiv p {
  font-size: 0.75rem;
  color: rgb(255, 244, 149);
  text-transform: uppercase;
}
.r_numdiv p i {
  font-weight: bold;
}
.me_main {
  bottom: 2%;
  left: 0;
}
.me_box {
  top: 15%;
  left: 0;
  padding: 0 1.5rem 0 2.3rem;
  width: 100%;
}
/* iphone 5 */
@media screen and (max-width: 320px) {
  html {
    font-size: 12px;
  }
}
.none_box {
  text-align: center;
  font-size: 0.85rem;
  color: #fdffe4;
}

/* 未开始的样式 */
.nostart_con {
  width: 100%;
  top: 35%;
}
.nostart_con img {
  width: 30%;
  margin: auto;
}
.text_no {
  width: 100%;
  color: #fff;
  font-size: 13px;
  text-align: center;
}
.p_te {
  width: 70%;
  margin: 16px auto;
  text-align: center;
  color: #bb9fd3;
  font-size: 0.625rem;
}
/* 活动结束的盒子样式 */
.over_box {
  top: 20%;
  width: 100%;
}
.over_box img {
  width: 60%;
  margin: auto;
}
.over_p {
  font-size: 0.75rem;
  color: #e9a6ff;
}
</style>